var render = function () {var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;
return _c('v-btn',{class:_vm.computedButtonClass,style:_vm.computedButtonStyle,attrs:{"to":{name:'contact-qna'}}},[_c('v-img',{attrs:{"src":_vm.imageSrc}}),_c('p',[_vm._v(_vm._s(_vm.$t('HomePage.floating.inquiry')))])],1);}
var staticRenderFns = []

export { render, staticRenderFns }